import React from 'react';
import HowItWorks from './HowItWorks';

const About = () => {
  return (
    <div>
      <HowItWorks />
    </div>
  );
};

export default About;
